module.exports = __webpack_public_path__ + "media/leadership/Allison-bbc9905e.jpg";